import React, { useEffect, useRef, useState } from "react";
import BackgroundLayout from "../Components/BackgroundLayout";
import Navbar from "../Components/Navbar";
import NavbarGenres from "../Components/NavbarGenres";
import {
  useGetDataByGenreIdQuery,
  useGetSeriesGenreListQuery,
  useGetTrendngDataQuery,
} from "../Slices/httpSlice";
import SectionDragCards, {
  fetchedDataType,
} from "../Components/Drag-Cards/SectionDragCards";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import MovieCard from "../Components/Drag-Cards/MovieCard";
import SkeletonCardsGrid from "../Components/SkeletonCardsGrid";
import DragCardsTitle from "../Components/Drag-Cards/DragCardsTitle";
import classes from "./Movies.module.css";
import { motion } from "framer-motion";
import NavbarMobile from "../Components/NavbarMobile";
import BottomNavbar from "../Components/BottomNavbar";
import { useLocation } from "react-router-dom";
import { resetSeriesGenre } from "../Slices/seriesGenreSlice";
import AuthModal from "../Components/Modals/AuthModal";
import SearchModal from "../Components/SearchModal";
import WatchlistModal from "../Components/WatchlistModal";
import UserRatingsModal from "../Components/UserRatingsModal";
import ProfileModal from "../Components/ProfileModal";
import Drawer from "../Components/Drawer";

const Series = () => {
  const [windowWidth, setWindowWidth] = useState<number>(0);

  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const resetState: undefined | true = location.state?.reset;
    if (resetState) {
      dispatch(resetSeriesGenre());
    }
  }, [location]);

  useEffect(() => {
    const updateConstraints = () => {
      setWindowWidth(window.innerWidth);
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, []);

  const { seriesGenre, seriesGenreId } = useAppSelector(
    (state) => state.seriesGenreSlice
  );

  const [pageNumber, setPageNumber] = useState<number>(1);

  const [genreDataArray, setGenreDataArray] = useState<[] | fetchedDataType[]>(
    []
  );

  const [fetchData, setFetchData] = useState<boolean>(false);

  const lastItemRef = useRef<HTMLDivElement | null>(null);

  const {
    data: movieGenresList,
    isFetching: genreLoading,
    error: genreError,
  } = useGetSeriesGenreListQuery(null);

  const {
    data: trending,
    refetch: trendingRefetch,
    isFetching: trendingLoading,
    error: trendingError,
  } = useGetTrendngDataQuery("tv");

  const {
    data: adventure,
    refetch: adventureRefetch,
    isFetching: adventureLoading,
    error: adventureError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 10759,
    pageNumber: 1,
  });

  const {
    data: comedy,
    refetch: comedyRefetch,
    isFetching: comedyLoading,
    error: comedyError,
  } = useGetDataByGenreIdQuery({ media: "tv", genreId: 35, pageNumber: 1 });

  const {
    data: scific,
    refetch: scificRefetch,
    isFetching: scificLoading,
    error: scificError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 10765,
    pageNumber: 1,
  });

  const {
    data: thriller,
    refetch: thrillerRefetch,
    isFetching: thrillerLoading,
    error: thrillerError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 80,
    pageNumber: 1,
  });

  const {
    data: animation,
    refetch: animationRefetch,
    isFetching: animationLoading,
    error: animationError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 16,
    pageNumber: 1,
  });

  const {
    data: mystery,
    refetch: mysteryRefetch,
    isFetching: mysteryLoading,
    error: mysteryError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 9648,
    pageNumber: 1,
  });

  const {
    data: documentary,
    refetch: documentaryRefetch,
    isFetching: documentaryLoading,
    error: documentaryError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 99,
    pageNumber: 1,
  });

  const {
    data: western,
    refetch: westernRefetch,
    isFetching: westernLoading,
    error: westernError,
  } = useGetDataByGenreIdQuery({
    media: "tv",
    genreId: 37,
    pageNumber: 1,
  });

  const {
    data: genreData,
    refetch: genreDataRefetch,
    isFetching: genreDataLoading,
    error: genreDataError,
  } = useGetDataByGenreIdQuery(
    {
      media: "tv",
      genreId: seriesGenreId,
      pageNumber: pageNumber,
    },
    {
      skip: seriesGenreId === null,
    }
  );

  useEffect(() => {
    setPageNumber(1);
    setFetchData(false);
    setGenreDataArray([]);
  }, [seriesGenreId]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && seriesGenreId !== null && !fetchData) {
          console.log("refetch data agian...");
          if (pageNumber <= 16) {
            console.log("Fetch Data only when pageNumber <=7 !");
            genreDataRefetch();
            setFetchData(true);
          }
        }
      },
      { threshold: 1.0 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [seriesGenreId, pageNumber, fetchData]);

  useEffect(() => {
    if (fetchData && !genreDataLoading) {
      if (seriesGenreId !== null && genreData) {
        setPageNumber((prevValue) => prevValue + 1);
        setGenreDataArray((prevArray) => {
          return prevArray.length > 0 ? [...prevArray, genreData] : [genreData];
        });
        setFetchData(false);
      }
    }
  }, [fetchData, genreData, genreDataLoading]);

  return (
    <>
      <BackgroundLayout paddingBottom={true}>
        <AuthModal />
        <NavbarMobile />
        <Navbar activeLink={3} />
        <NavbarGenres
          genreType="series"
          genres={movieGenresList}
          genreLoading={genreLoading}
        />
        {seriesGenre === "all" ? (
          <SectionDragCards
            hideFilter={true}
            style={{ paddingBottom: "20px" }}
            trending={trending}
            adventure={adventure}
            comedy={comedy}
            scific={scific}
            thriller={thriller}
            animation={animation}
            mystery={mystery}
            documentary={documentary}
            western={western}
            trendingLoading={trendingLoading}
            adventureLoading={adventureLoading}
            comedyLoading={comedyLoading}
            scificLoading={scificLoading}
            thrillerLoading={thrillerLoading}
            animationLoading={animationLoading}
            documentaryLoading={documentaryLoading}
            westernLoading={westernLoading}
            mysteryLoading={mysteryLoading}
            trendingError={trendingError}
            adventureError={adventureError}
            comedyError={comedyError}
            scificError={scificError}
            thrillerError={thrillerError}
            animationError={animationError}
            mysteryError={mysteryError}
            documentaryError={documentaryError}
            westernError={westernError}
            checkAndNavigate={false}
            navigateToMovies={false}
            navigateToSeries={true}
          />
        ) : (
          <div className={classes.section_drag_cards}>
            <div className={classes.section_cards}>
              <DragCardsTitle
              // Popular Series in
                title={`လူကြိုက်များသောစီးရီးများ ${seriesGenre}`}
                hideFilter={true}
              />

              {genreDataArray?.map((data, idx) => {
                return (
                  <motion.div
                    key={idx}
                    className={classes.section_card}
                    style={{
                      gridTemplateColumns: `repeat(${genreDataArray[idx]?.result?.results?.length}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left: -(windowWidth <= 800
                        ? 10 +
                          genreDataArray[idx]?.result?.results.length * 150 +
                          genreDataArray[idx]?.result?.results.length * 10 +
                          genreDataArray[idx]?.result?.results.length * 1 -
                          windowWidth
                        : window.innerWidth * 0.05 +
                          genreDataArray[idx]?.result?.results.length * 150 +
                          genreDataArray[idx]?.result?.results.length * 10 +
                          genreDataArray[idx]?.result?.results.length * 1 -
                          windowWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    {data?.result?.results?.map((dataItem, idx2) => (
                      <MovieCard
                        key={`${idx}-${idx2}`}
                        data={dataItem}
                        navigateTo="series"
                      />
                    ))}
                  </motion.div>
                );
              })}

              {genreDataLoading && <SkeletonCardsGrid />}
              {pageNumber === 16 ? null : (
                <div ref={lastItemRef} className={classes.load_item}></div>
              )}
            </div>
          </div>
        )}
      </BackgroundLayout>
      <BottomNavbar activeLink={3} />
      <SearchModal />
      <WatchlistModal />
      <UserRatingsModal />
      <ProfileModal />
      <Drawer />


    </>
  );
};

export default Series;
